import React from "react";
import { convertValue } from "@/features/campaigns/email/utils/emailCampaignHelper";

type SummaryData = {
  emailsSent?: number;
  delivered?: number;
  uniqueOpens?: number;
  uniqueClicks?: number;
  conversions?: number;
  bounces?: number;
};

type CountCard = {
  key: keyof SummaryData;
  value?: number;
  label: string;
  color: string;
  total?: number;
};

const EmailCampaignCountDisplay = ({
  summaryData,
  selectedTab,
}: {
  summaryData?: SummaryData;
  selectedTab?: number;
}) => {
  const {
    emailsSent,
    delivered,
    uniqueOpens,
    uniqueClicks,
    conversions,
    bounces,
  } = summaryData || {};

  const countCards: CountCard[] = [
    {
      key: "emailsSent",
      value: emailsSent,
      label: "Emails Sent",
      color: "#28a745",
    },
    {
      key: "delivered",
      value: delivered,
      label: "Delivered",
      color: "#007bff",
      total: emailsSent,
    },
    {
      key: "uniqueOpens",
      value: uniqueOpens,
      label: "Unique Opens",
      color: "#6f42c1",
      total: emailsSent,
    },
    {
      key: "uniqueClicks",
      value: uniqueClicks,
      label: "Unique Clicks",
      color: "#fd7e14",
      total: emailsSent,
    },
    {
      key: "conversions",
      value: conversions,
      label: "Conversions",
      color: "#007bff",
      total: emailsSent,
    },
    {
      key: "bounces",
      value: bounces,
      label: "Bounces",
      color: "#dc3545",
      total: emailsSent,
    },
  ];

  const getDisplayValue = (card) => {
    const isPercentageView = selectedTab === 1; // 0 = #, 1 = %
    const targetType = isPercentageView ? "percentage" : "number";

    if (card.key === "emailsSent") {
      // Emails Sent is always shown as number
      return convertValue(card.value, "number");
    }

    return convertValue(card.value, targetType, card.total);
  };

  return (
    <div className="row g-3">
      {countCards.map((card) => (
        <div
          key={card.key}
          className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mt-2"
        >
          <div
            className="count-card h-100 p-4 text-center"
            style={{
              background: "var(--neutral-white)",
              borderRadius: "var(--radius-container)",
              boxShadow: "none",
              border: "1px solid var(--neutral-200)",
            }}
          >
            <div
              className="count-value mb-2"
              style={{
                fontSize: "2rem",
                fontWeight: "700",
                lineHeight: "1",
                color: card.color,
              }}
            >
              {getDisplayValue(card)}
            </div>
            <div className="count-label">{card.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EmailCampaignCountDisplay;
